import { Cutlery, Lock } from '@creditornot/cb-icons';
import { cssThemedValue } from '@creditornot/cb-ingredients';
import { Popover } from '@creditornot/cb-popover';
import { Tag } from '@creditornot/cb-tag';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

type RestrictedVenueLevelHeaderProps = {
  selectionName: string;
};

const Root = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 24px;
  height: 85px;
  border-block-end: 1px solid ${cssThemedValue('borderPrimary')};
`;

const PopoverContent = styled.div`
  max-width: 300px;
`;

export const RestrictedVenueLevelHeader = ({ selectionName }: RestrictedVenueLevelHeaderProps) => {
  return (
    <Root>
      <T.Heading4>
        <FormattedMessage id="menu.menu-sync.status-header" />
      </T.Heading4>
      <Tag size="small" variant="lightDarkBlue" icon={<Cutlery />}>
        {selectionName}
      </Tag>
      <Popover
        placement="left"
        content={
          <PopoverContent>
            <T.Body3>
              <FormattedMessage id="listing-manager.selections.venue-editor.restricted-editing.description" />
            </T.Body3>
          </PopoverContent>
        }
      >
        <Tag size="small" variant="lightOrange" icon={<Lock />}>
          <FormattedMessage id="shared-menu.link.venue.restricted-editing.label" />
        </Tag>
      </Popover>
    </Root>
  );
};
